import { WarrantyUPKitModel } from '../config/RayCodes';

// BUG-167 (B-2): 제품 model + raycode 목록으로 warranty 제품타입(CT/UP KIT/PRD) 도출.
// - UP KIT: WarrantyUPKitModel 매칭 / CT: raycode category === 'Extra-oral Imaging' / 그 외: PRD.
// - model/코드 미확정 시 PRD 로 안전 폴백 (BE warrantyType !== 'CT' → Product-only 와 일치).
export const resolveWarrantyType = (model, codeList = []) => {
    if (!model) return 'PRD';
    if (WarrantyUPKitModel.some(x => x.code === model)) return 'UP KIT';
    const list = Array.isArray(codeList) ? codeList : [];
    const code = list.find(x => x.type === 'PRODUCTOPTION' && x.group === model);
    return code?.category === 'Extra-oral Imaging' ? 'CT' : 'PRD';
};
